import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Preconnect to API immediately
if (typeof document !== 'undefined') {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = 'https://mission.esoft.family';
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

